import React, { useCallback, useEffect, useState } from "react";
import Page from "../../Components/Page";
import { Box, Button, Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AlertComponent from "../../Components/AlertComponent";
import FetchHook from "../../Api/FetchHooks";
import WalletBalances from "./Components/WalletBalances";
import UserInfoCard from "./Components/UserInfoCard";
import UserActions from "./Components/UserActions";
import UserRecentTransactions from "./Components/UserRecentTransactions";
import UserTabs from "./UserTabs";

const UserProfile3 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const LoggedInUser = useSelector((state) => state.auth.user);

  const [user, setUser] = useState(location.state?.user || LoggedInUser);

  const [balances, setBalances] = useState([]);
  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  // --- API HOOKS ---
  const [userLoading, userResponse, userRequest] = FetchHook();
  const [balanceLoading, balanceResponse, balanceRequest] = FetchHook();

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const userId = user?.id;
  const fetchData = useCallback(async () => {
    if (!userId) return;

    balanceRequest({
      url: `/account_bal?entity_id='${userId}'&type="customer"`,
    });

    userRequest({ url: `/entity?type=customer&entity_id=${userId}` });
  }, [userId, balanceRequest, userRequest]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (userResponse?.data?.Data?.[0]) setUser(userResponse.data.Data[0]);
    if (balanceResponse?.data?.Loan) setBalances(balanceResponse.data.Loan);
  }, [userResponse, balanceResponse]);

  return (
    <Page
      title={"User Profile"}
      actions={
        <Box>
          {location.pathname !== "/dashboard" && (
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          )}
        </Box>
      }
    >
      <Box>
        <AlertComponent
          open={snackbar.open}
          handleSnackbar={handleCloseSnackbar}
          severity={{ severity: snackbar.severity, message: snackbar.message }}
        />

        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <UserInfoCard user={user} fetchData={fetchData} />
          </Grid>
          {user.role === "customer" && (
            <Grid item xs={12} md={12}>
              <WalletBalances balances={balances} loading={balanceLoading} />
            </Grid>
          )}

          {user.role === "customer" && (
            <Grid item xs={12} md={12}>
              <UserTabs user={user} fetchUser={fetchData} />{" "}
            </Grid>
          )}

          {/* <Grid item xs={12} md={7}>
            <UserRecentTransactions user={user} loading={balanceLoading} />
          </Grid> */}
          {/* <Grid item xs={12} md={5}>
            <UserActions
              user={user}
              LoggedInUser={LoggedInUser}
              fetchData={() => fetchData()}
            />
          </Grid> */}
          {/* <Grid item sm={12} lg={6}> */}
          {/* <UserActions
            user={user}
            LoggedInUser={LoggedInUser}
            fetchData={fetchData}
          />
        </Grid> */}
        </Grid>

        {/* <UserTabs user={user} fetchUser={fetchData} /> */}
      </Box>
    </Page>
  );
};

export default UserProfile3;
